import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import i18n from '@/lang'
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
});
import './style/index.css'
import '@/style/loading.css'
import './assets/font/iconfont.css'
Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
